import * as Components from "../";
import { Input } from "antd";
import { motion } from "framer-motion";
import { CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useMotionHook } from "../../hooks/motionHook";
import { owntoast } from "../../utils";
import UsefulFunctions from "../../utils/UsefulFunctions";
function ListItem(props) {
  const { item, i } = props;
  const animations = useMotionHook();
  const removeProduct = (product) => props.removeSaleList(product);

  const changeQty = (e) => {
    if (e.target.value) {
      if (!isNaN(+e.target.value)) {
        if (e.target.value > 0) {
          if (e.target.value <= 999) {
            props.addSaleList({
              ...item,
              type: "qty",
              qty: Number(e.target.value),
            });
          } else {
            owntoast("999 с дээш оруулж болохгүй.", "error");
          }
        }
      }
    }
  };

  const isSelectedProduct = (item) => {
    if (props.activeProduct) {
      if (props.activeProduct.isset) {
        return UsefulFunctions.checkSetProducts(
          item.setdetails,
          props.activeProduct.setdetails
        );
      } else {
        if (
          props.activeProduct.productid === item.productid &&
          props.activeProduct.spiceid === item.spiceid
        )
          return true;
      }
    }
    return false;
  };

  const renderSpices = () => {
    let tmp;
    if (item.isset && item.setdetails) {
      tmp = item.setdetails.map((detail, detailIndex) => {
        return (
          <span
            key={detailIndex}
            className="text-black text-xs text-mainOrange mt-1"
          >{`${detail.productname} ${
            detail.spiceid && detail.spicename ? `/${detail.spicename}/` : ""
          }  `}</span>
        );
      });
    } else if (item.spiceid && item.spicename) {
      return (
        <span className="text-black text-xs text-mainOrange mt-1">
          {item.spicename}
        </span>
      );
    }
    return tmp;
  };

  return (
    <motion.div
      {...animations}
      onClick={() => {
        props.setActiveProduct({ ...item });
      }}
      className={`grid grid-cols-12 grid-rows-2 gap-1 p-2 rounded-md ${
        i % 2 === 0 ? "bg-primaryOpa" : ""
      } ${
        isSelectedProduct(item)
          ? "border-2 border-primary transition-all delay-75"
          : ""
      }`}
    >
      <div className="col-span-6 row-span-2 flex">
        <Components.Ripple
          className="bg-buttonGrey text-white min-w-[20px] h-[20px] w-[20px] flex items-center justify-center rounded-sm row-span-2 col-span-8 "
          onClick={() => removeProduct(item)}
        >
          <CloseOutlined className="text-xs flex items-center justify-center" />
        </Components.Ripple>
        <div className="ml-3 flex flex-col w-full">
          <span className="text-black">{item.productname}</span>
          {renderSpices()}
          {/* {item.isset &&
            item.setdetails &&
            item.setdetails.map((detail, detailIndex) => {
              if (detail.spiceid && detail.spicename) {
                return (
                  <span
                    key={detailIndex}
                    className="text-black text-xs text-mainOrange mt-1"
                  >{`${detail.productname} /${detail.spicename}/`}</span>
                );
              }
            })} */}
        </div>
      </div>
      {item.unitdiscount ? (
        <div className="col-span-6 row-span-1 flex justify-end items-center">
          <span className="text-grey text-xs ml-3 w-18 text-right line-through">
            {new Intl.NumberFormat().format(item.price)}
          </span>
          <span className="text-black ml-1 w-18 text-right">
            {new Intl.NumberFormat().format(item.price - item.unitdiscount)}
          </span>
        </div>
      ) : (
        <div className="col-span-6 row-span-1 flex justify-end">
          <span className="text-black ml-3 w-18 text-right">
            {new Intl.NumberFormat().format(item.price)}
          </span>
        </div>
      )}

      <div className="col-span-6 row-span-1 flex justify-end ">
        <Components.Ripple
          className="bg-primary w-6 h-6 flex items-center justify-center rounded-sm"
          onClick={() => {
            if (item.qty > 1) {
              props.addSaleList({ ...item, type: "minus" });
            }
          }}
        >
          <MinusOutlined className="text-xs  flex items-center justify-center text-white" />
        </Components.Ripple>
        <Input
          className="w-10 mx-2 h-6 text-center p-1"
          onChange={changeQty}
          value={item.qty}
        />
        {/* <div className="w-8 text-center">{item.qty}</div> */}
        <Components.Ripple
          className="bg-primary w-6 h-6 flex items-center justify-center rounded-sm"
          onClick={() => {
            props.addSaleList({ ...item, type: "plus" });
          }}
        >
          <PlusOutlined className="text-xs flex items-center justify-center text-white" />
        </Components.Ripple>
        <span className="text-black ml-3 w-16 text-right font-semibold">
          {new Intl.NumberFormat().format(item.amount)}
        </span>
      </div>
    </motion.div>
  );
}

export default ListItem;
